<template>
  <div class="c-baseTextarea c-form__item">
    <FormLabel :label="label" :hint="hint" :required="required" />
    <ValidationProvider v-bind="veeProps" v-slot="{ errors, failed }">
      <textarea
        :value="value"
        :rows="rows"
        v-bind="$attrs"
        class="c-baseTextarea__control c-formControl"
        :class="{ 'has-error': failed, 'is-disabled': disabled }"
        @input="$emit('input', $event.target.value)" />
      <div v-if="errors[0]" class="c-errorMessage">{{ errors[0] }}</div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },

    rows: {
      type: Number,
      default: 4
    },

    required: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ''
    },

    hint: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    veeProps: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
